import { initializeApp } from "firebase/app";
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytes,
  deleteObject,
  listAll,
} from "firebase/storage";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";

import {
  getFirestore,
  onSnapshot,
  collection,
  writeBatch,
  setDoc,
  QuerySnapshot,
  deleteField,
  doc,
  query,
  deleteDoc,
  where,
  getDoc,
  updateDoc,
  getDocs,
  orderBy,
  limit,
  or,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import {
  OAuthProvider,
  getAuth,
  signInWithPopup,
  onAuthStateChanged,
  setPersistence,
  browserLocalPersistence,
  signInWithRedirect,
  NextOrObserver,
  User,
  signOut,
} from "firebase/auth";

import { getFunctions } from "firebase/functions";

import { generateRandomString } from "./Helpers/ReportDataFunctions";

import { StoryData } from "./Types/Database/StoriesData";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCOZtevtHswnl5oIzpopJyIMPuDT5wvERg",
  authDomain: "hillsong-pastoral-care.firebaseapp.com",
  projectId: "hillsong-pastoral-care",
  storageBucket: "hillsong-pastoral-care.appspot.com",
  messagingSenderId: "119719295446",
  appId: "1:119719295446:web:caaf3f642cd8bcaed3cc77",
  measurementId: "G-9JG86NW88D",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);
export const auth = getAuth();
export const functions = getFunctions(app);

// Firebase Auth
function browserNeedsPopUp() {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) ||
    (/Safari/i.test(navigator.userAgent) &&
      !/iPhone|iPad|iPod/i.test(navigator.userAgent))
  );
}

//signin with microsoft
export async function microsoftSignIn() {
  const provider = new OAuthProvider("microsoft.com");
  provider.setCustomParameters({
    tenant: "37891f6c-61a3-49e7-b825-e7eb7734f450",
  });
  const auth = getAuth();

  return await signInWithPopup(auth, provider).catch((error) => {
    console.log(error.email);
    console.log(error);
  });
}

export const oktaSignIn = () => {
  return new Promise((resolve, reject) => {
    // Use localStorage for persistence
    setPersistence(auth, browserLocalPersistence).then(() => {
      const provider = new OAuthProvider("oidc.okta");

      // Check if popups are allowed
      if (true) {
        signInWithPopup(auth, provider)
          .then((result) => {
            resolve(result.user);
            return result.user;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // Use redirect method if popups are blocked
        signInWithRedirect(auth, provider)
          .then((result) => {
            if (result) resolve(result);
            console.log(result);
            return result;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  });
};

export const userStateListener = (callback: NextOrObserver<User>) => {
  return onAuthStateChanged(auth, callback);
};

export const SignOutUser = async () => await signOut(auth);

/* ------------------  FIRESTORE ------------------ */
const FIREBASE_QUERY_PARAM_LIMIT = 30;
const practiceDataBase = {
  PCReports: "PCReports",
  users: "UsersDatabase",
  PCAdmins: "PCAdmins",
  PCOrgTree: "PCOrgTree",
  PCStories: "PCStories",
  PCHotTopics: "PCHotTopics",
  PCCheatSheets: "PCCheatSheets",
};
/* --------  Collections -------- */

export const moveCollection = async (
  collectionName: string,
  newCollectionName: string
) => {
  const fetchedData = await getDocs(collection(db, collectionName));
  const newCollectionRef = collection(db, newCollectionName);

  fetchedData.docs.forEach((docSnapshot) => {
    const docRef = doc(newCollectionRef, docSnapshot.id);
    try {
      setDoc(docRef, docSnapshot.data(), { merge: true });
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  });
};

export const deleteCollection = async (collectionName: string) => {
  const fetchedData = await getDocs(collection(db, collectionName));
  const data: any[] = [];
  fetchedData.docs.forEach((doc) => {
    deleteDoc(doc.ref);
  });
  return data;
};
/* --------  Users -------- */
export const listenAndSetCurrentUser = (
  userFirebaseUid: string,
  userFirebaseEmail: string,
  callback: (userData: UserData | null) => void
) => {
  const userRef = collection(db, practiceDataBase.users);
  const q = query(
    userRef,
    or(
      where("email", "array-contains", userFirebaseEmail),
      where("firebaseUid", "array-contains", userFirebaseUid)
    )
  );

  return onSnapshot(q, (querySnapshot) => {
    const userDoc = querySnapshot.docs[0];

    if (userDoc) {
      const userData = userDoc.data() as UserData;

      if (userData.email.indexOf(userFirebaseEmail) === -1) {
        userData.email.push(userFirebaseEmail);
        updateDoc(userDoc.ref, {
          email: arrayUnion(userFirebaseEmail),
        });
      }

      if (
        !userData.firebaseUid ||
        userData.firebaseUid.indexOf(userFirebaseUid) === -1
      ) {
        !userData.firebaseUid && (userData.firebaseUid = []);
        userData.firebaseUid.push(userFirebaseUid);
        updateDoc(userDoc.ref, {
          firebaseUid: arrayUnion(userFirebaseUid),
        });
      }

      callback(userData);
    } else {
      console.error("User document not found!");
      callback(null);
    }
  });
};

export const uploadUserDatabase = async (UserDatabase: UserData[]) => {
  UserDatabase.forEach((user) => {
    try {
      const userRef = doc(db, practiceDataBase.users, user.userId);
      setDoc(userRef, user);
      console.log("Document written with ID: ", user.userId);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  });
};

export const uploadUser = async (user: UserData) => {
  try {
    const userRef = doc(db, practiceDataBase.users, user.userId);
    setDoc(userRef, user, { merge: true });
    console.log("Document written with ID: ", user.userId);
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

export const getUserDatabase = async () => {
  const fetchedData = await getDocs(collection(db, practiceDataBase.users));
  const users: UserData[] = [];
  fetchedData.docs.forEach((doc) => {
    users.push(doc.data() as UserData);
  });
  return users;
};

export const listenToUserDatabase = (callback: (data: UserData[]) => void) => {
  const unsubscribe = onSnapshot(
    collection(db, practiceDataBase.users),
    (snapshot) => {
      const users: UserData[] = [];
      snapshot.docs.forEach((doc) => {
        users.push(doc.data() as UserData);
      });
      callback(users);
    }
  );
  return unsubscribe;
};
export const listenToSelectUserDatabase = (
  userIds: string[],
  callback: (data: UserData[]) => void
): (() => void) => {
  const userDatabaseRef = collection(db, practiceDataBase.users);
  const unsubscribeFunctions: (() => void)[] = [];
  const allUsers: Map<string, UserData> = new Map();

  for (const userId of userIds) {
    // Create a query for each userId
    const q = query(userDatabaseRef, where("userId", "==", userId));

    // Listen to the snapshot for each query
    const unsubscribe = onSnapshot(q, (snapshot) => {
      snapshot.docs.forEach((doc) => {
        const matchingUser = doc.data() as UserData;
        allUsers.set(matchingUser.userId, matchingUser);
      });
      callback(Array.from(allUsers.values()));
      // Store the unsubscribe function for each listener
    });
    // Convert the Map values to an array and pass to the callback
    unsubscribeFunctions.push(unsubscribe);
  }
  // Return a single function that will unsubscribe from all listeners
  return () => {
    for (const unsubscribe of unsubscribeFunctions) {
      unsubscribe();
    }
  };
};

export const addUserToAdmin = (user: UserData, level: string) => {
  const adminCollectionRef = collection(db, practiceDataBase.PCAdmins);
  if (!user.firebaseUid) return;
  const adminRef = doc(adminCollectionRef, user.firebaseUid[0]);
  const adminUserDoc = {
    admin: true,
    level: level,
  };
  setDoc(adminRef, adminUserDoc, { merge: true });
};

export const removeUserFromAdmin = (user: UserData) => {
  const adminCollectionRef = collection(db, practiceDataBase.PCAdmins);
  if (!user.firebaseUid) return;
  const adminRef = doc(adminCollectionRef, user.firebaseUid[0]);
  deleteDoc(adminRef);
};

//search for user by firstName, lastName or email
export const searchUserDatabase = async (
  email: string
): Promise<UserData[]> => {
  const userRef = collection(db, practiceDataBase.users);
  const q = query(
    userRef,
    or(where("email", "array-contains", email.toLowerCase()))
  );
  const querySnapshot = await getDocs(q);
  const users: UserData[] = [];
  querySnapshot.forEach((doc) => {
    users.push(doc.data() as UserData);
  });
  console.log("return from user search: ", users);
  return users;
};

export const listenToCurrentUser = (
  userFirebaseUid: string,
  callback: (data: UserData) => void
) => {
  const userRef = doc(db, practiceDataBase.users, userFirebaseUid);

  const unsubscribe = onSnapshot(userRef, (docSnapshot) => {
    if (docSnapshot.exists()) {
      const userData = docSnapshot.data() as UserData;
      callback(userData);
    } else {
      console.error("User document not found!");
    }
  });

  return unsubscribe;
};

/* --------  OrgTree  -------- */

export const saveOrgTree = async (orgTree: OrgTreeItem) => {
  try {
    const orgTreeRef = doc(db, practiceDataBase.PCOrgTree, "A1B2C3D4E0");
    await setDoc(orgTreeRef, orgTree, { merge: true });
  } catch (e) {
    console.error("Error updating document: ", e);
  }
};

export const listenToOrgTreeDatabase = (
  callback: (data: OrgTreeItem | undefined) => void
) => {
  const docRef = doc(db, practiceDataBase.PCOrgTree, "A1B2C3D4E0");

  const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
    if (docSnapshot.exists()) {
      const docData = docSnapshot.data() as OrgTreeItem;
      callback(docData);
    } else {
      console.warn("Document does not exist!");
      callback(undefined);
    }
  });

  // Return the unsubscribe function so you can stop listening when needed
  return unsubscribe;
};

/* --------  Reports  -------- */

//download all the reports in reportDatabase and return an array of them
export const listenToReportDatabase = (
  callback: (reports: ReportData[]) => void
) => {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);

  const unsubscribe = onSnapshot(reportBucketsRef, (allBucketsSnapshot) => {
    const reports: ReportData[] = [];

    allBucketsSnapshot.docs.forEach((bucketSnapshot) => {
      const bucketData = bucketSnapshot.data() as CampusReportBucket;

      for (const reportId in bucketData.reports) {
        reports.push(bucketData.reports[reportId]);
      }
    });

    callback(reports);
  });

  return unsubscribe;
};

export const setupReportListeners = (
  teamIds: string[],
  callback: (reports: ReportData[]) => void
): (() => void) => {
  const reportDatabaseRef = collection(db, practiceDataBase.PCReports);
  const unsubscribeFunctions: (() => void)[] = [];
  // Use a Map instead of an array to avoid duplicates
  const reportsMap: Map<string, ReportData> = new Map();

  for (const teamId of teamIds) {
    const q = query(reportDatabaseRef, where("teamId", "==", teamId));
    const unsubscribe = onSnapshot(q, (snapshot: QuerySnapshot) => {
      snapshot.forEach((doc) => {
        const matchingBuckets = doc.data() as CampusReportBucket;
        const reportsFromBucket = Object.values(matchingBuckets.reports);
        reportsFromBucket.forEach((report) => {
          // Update or add the report to the Map
          reportsMap.set(report.reportId, report);
        });
      });
      // Convert the Map values to an array and pass to the callback
      callback(Array.from(reportsMap.values()));
    });
    unsubscribeFunctions.push(unsubscribe);
  }

  // Return a single function that will unsubscribe from all listeners
  return () => {
    for (const unsubscribe of unsubscribeFunctions) {
      unsubscribe();
    }
  };
};

export const queryReportDatabaseByCampus = async (teamId: string) => {
  const q = query(
    collection(db, practiceDataBase.PCReports),
    where("teamId", "==", teamId)
  );

  const querySnapshot = await getDocs(q);
  const reportArray: ReportData[] = [];
  querySnapshot.forEach((doc) => {
    reportArray.push(doc.data().reports);
  });
  return reportArray;
};

export async function saveOrUpdateReport(reportToSave: ReportData) {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);

  // If the report has a bucketId, try to update it
  if (reportToSave.bucketId) {
    const bucketRef = doc(reportBucketsRef, reportToSave.bucketId);
    await updateDoc(bucketRef, {
      [`reports.${reportToSave.reportId}`]: reportToSave,
    }).then(() => {});
    return;
  }
  // If the report doesn't have a bucketId or wasn't found in the specified bucket
  const queryRef = query(
    reportBucketsRef,
    where("teamId", "==", reportToSave.teamId)
  );

  const bucketsSnapshot = await getDocs(queryRef);
  let availableBucket: CampusReportBucket | undefined;

  bucketsSnapshot.forEach((docSnapshot) => {
    const bucket = docSnapshot.data() as CampusReportBucket;
    const bucketArray = Object.values(bucket.reports); // Simplified way to get all reports from the map

    if (bucket.teamId === reportToSave.teamId && bucketArray.length < 300) {
      availableBucket = bucket;
    }
  });

  if (availableBucket && reportToSave.reportId) {
    reportToSave.bucketId = availableBucket.bucketId;
    availableBucket.reports[reportToSave.reportId] = reportToSave;
    const bucketRef = doc(reportBucketsRef, availableBucket.bucketId);
    console.log("saving to existing bucket");
    await updateDoc(bucketRef, {
      reports: availableBucket.reports,
    });
    return;
  } else {
    const ramdomBucketId = generateRandomString();
    reportToSave.bucketId = ramdomBucketId;
    const newBucket: CampusReportBucket = {
      teamId: reportToSave.teamId,
      bucketId: ramdomBucketId,
      reports: { [`${reportToSave.reportId}`]: reportToSave },
    } as CampusReportBucket;
    const newBucketRef = doc(reportBucketsRef, ramdomBucketId);
    console.log("saving to new bucket");
    setDoc(newBucketRef, newBucket, { merge: true });
    return;
  }
}

export const deleteAllReports = async () => {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);
  const q = query(reportBucketsRef, where("teamId", "==", "A1B2C3D4E1"));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    console.log(`Deleting bucket ${doc.id}...`);
    deleteDoc(doc.ref);
  });
};

//delete all reports that are imported
export const deleteImportedReports = async () => {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);
  const querySnapshot = await getDocs(reportBucketsRef);
  querySnapshot.forEach((docSnapshot) => {
    // Renamed 'doc' to 'docSnapshot' to avoid confusion with the 'doc' function
    const bucket = docSnapshot.data() as CampusReportBucket;
    console.log(bucket.reports);
    const bucketArray = Object.values(bucket.reports);
    bucketArray.forEach((report) => {
      if (report.importedData) {
        delete bucket.reports[report.reportId];
      }
    });
    if (Object.keys(bucket.reports).length === 0) {
      deleteDoc(docSnapshot.ref);
    } else {
      const bucketRef = doc(db, practiceDataBase.PCReports, bucket.bucketId);
      setDoc(bucketRef, bucket);
    }
  });
};

export const uploadImportReports = async (reports: ReportData[]) => {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);

  // Group reports by teamId
  const groupedReports: { [teamId: string]: ReportData[] } = {};
  reports.forEach((report) => {
    if (!groupedReports[report.teamId]) {
      groupedReports[report.teamId] = [];
    }
    groupedReports[report.teamId].push(report);
  });

  const generatedBucketIds: string[] = [];

  // Helper function to generate a unique bucketId
  const generateUniqueBucketId = () => {
    let newBucketId = generateRandomString();
    while (generatedBucketIds.includes(newBucketId)) {
      newBucketId = generateRandomString();
    }
    generatedBucketIds.push(newBucketId);
    return newBucketId;
  };

  // Create new bucket objects and store them in Firestore
  for (const teamId in groupedReports) {
    let reportsForTeam = groupedReports[teamId];
    while (reportsForTeam.length > 0) {
      const reportsForBucket = reportsForTeam.splice(0, 300); // Take up to 300 reports for a bucket
      const newBucketId = generateUniqueBucketId();
      const newBucket: CampusReportBucket = {
        teamId: teamId,
        bucketId: newBucketId,
        reports: {},
      };

      reportsForBucket.forEach((report) => {
        report.bucketId = newBucketId; // Update the bucketId of the report
        newBucket.reports[report.reportId] = report; // Use reportId as the key
      });

      // Store the new bucket in Firestore using the bucketId as the document ID
      const newBucketRef = doc(reportBucketsRef, newBucketId);
      await setDoc(newBucketRef, newBucket);
    }
  }
};

export const changeStatusProperties = async () => {
  const BATCH_SIZE = 1;
  const DELAY_BETWEEN_BATCHES = 1000;
  const usersRef = collection(db, practiceDataBase.PCReports);
  const snapshot = await getDocs(usersRef);

  let batch = writeBatch(db);
  let counter = 0;

  snapshot.docs.forEach((doc) => {
    const bucket = doc.data();
    const newBucket = { ...bucket };
    for (const reportKey in newBucket.reports) {
      const report = newBucket.reports[reportKey] as ReportData;
      if (
        report.involvement === "volunteer" ||
        report.involvement === "Volunteer" ||
        report.involvement === "Pastoral Care Volunteer" ||
        report.involvement === ""
      ) {
        report.involvement = "volunteer";
      } else if (
        report.involvement === "churchStaff" ||
        report.involvement === "Church Staff" ||
        report.involvement === "Staff Member" ||
        report.involvement === "Hillsong Staff" ||
        report.involvement === "Hillsong Church Staff"
      ) {
        report.involvement = "churchStaff";
      } else if (
        report.involvement === "pastoralCare" ||
        report.involvement === "Pastoral Care Staff" ||
        report.involvement === "Pastoral Care"
      ) {
        report.involvement = "pastoralCare";
      } else if (report.involvement === "campusPastor") {
        report.involvement = "campusPastor";
      } else if (report.involvement === "oversight") {
        report.involvement = "oversight";
      } else if (report.involvement === "admin") {
        report.involvement = "admin";
      }
    }
    batch.update(doc.ref, newBucket);
    counter++;

    if (counter >= BATCH_SIZE) {
      // Wrap the code that uses await inside an async function
      (async () => {
        await batch.commit();
        await new Promise((resolve) =>
          setTimeout(resolve, DELAY_BETWEEN_BATCHES)
        ); // Introduce delay
      })();
      batch = writeBatch(db);
      counter = 0;
    }
  });

  if (counter > 0) {
    await batch.commit();
  }
};

export const deleteReport = async (report: ReportData) => {
  const reportBucketsRef = collection(db, practiceDataBase.PCReports);
  const bucketRef = doc(reportBucketsRef, report.bucketId);
  console.log(`Erasing report ${report.reportId} from database`);
  await updateDoc(bucketRef, {
    [`reports.${report.reportId}`]: deleteField(),
  });
};

/* --------  Stories -------- */

export const writeAndEditStory = async (story: StoryData): Promise<void> => {
  try {
    const storyRef = doc(db, practiceDataBase.PCStories, story.storyId);
    await setDoc(storyRef, story, { merge: true });
  } catch (e) {
    console.error("Error updating document: ", e);
  }
};

export const deleteStory = async (storyId: string): Promise<void> => {
  try {
    const storyRef = doc(db, practiceDataBase.PCStories, storyId);
    await deleteDoc(storyRef);
  } catch (e) {
    console.error("Error deleting document: ", e);
  }
};

export const listenToTenMostRecentStories = (
  callback: (data: StoryData[]) => void,
  numberOfStoriesToGet: number = 10
) => {
  let storyQuery = query(
    collection(db, practiceDataBase.PCStories),
    orderBy("date", "desc"),
    limit(numberOfStoriesToGet)
  );

  const unsubscribe = onSnapshot(storyQuery, (snapshot) => {
    const stories: StoryData[] = [];
    snapshot.docs.forEach((doc) => {
      const storyData = doc.data() as StoryData;
      stories.push(storyData);
    });
    callback(stories);
  });

  // Return the unsubscribe function so you can stop listening when needed
  return unsubscribe;
};

/* --------  Hot Topics -------- */
export function writeToHotTopicsDatabase(hotTopic: HotTopic) {
  const ref = doc(db, practiceDataBase.PCHotTopics, "hotTopicsDatabase");

  // Replace spaces with underscores
  !hotTopic.hotTopicId && (hotTopic.hotTopicId = generateRandomString());

  const keyWordsReformted = hotTopic.keyWords?.map((keyWord: string) =>
    keyWord.trim().toLowerCase()
  );

  const cleanHotTopic = {
    ...hotTopic,
    label: hotTopic.label.trim().toLowerCase(),
    keyWords: keyWordsReformted,
  };

  try {
    updateDoc(ref, {
      [hotTopic.hotTopicId]: cleanHotTopic,
    });
  } catch (e) {
    console.error("Error adding Hot Topic to Hot Topics Database: ", e);
  }
}

export const listenToHotTopicsDatabase = (
  callback: (data: HotTopic[]) => void
) => {
  const docRef = doc(db, practiceDataBase.PCHotTopics, "hotTopicsDatabase");

  const unsubscribe = onSnapshot(docRef, (docSnapshot) => {
    if (docSnapshot.exists()) {
      const docData = docSnapshot.data();
      let hotTopicsArray: HotTopic[] = [];
      for (let key in docData) {
        if (docData.hasOwnProperty(key)) {
          hotTopicsArray.push(docData[key] as HotTopic);
        }
      }
      callback(hotTopicsArray);
    } else {
      console.warn("Document does not exist!");
      callback([]);
    }
  });

  // Return the unsubscribe function so you can stop listening when needed
  return unsubscribe;
};

export const deleteHotTopic = async (hotTopicId: string) => {
  const ref = doc(db, practiceDataBase.PCHotTopics, "hotTopicsDatabase");

  try {
    updateDoc(ref, {
      [hotTopicId]: deleteField(),
    });
  } catch (e) {
    console.error("Error deleting Hot Topic from Hot Topics Database: ", e);
  }
};

export const reformatHotTopicsDatabase = async () => {
  const docRef = doc(db, practiceDataBase.PCHotTopics, "hotTopicsDatabase");
  const docSnapshot = await getDoc(docRef);
  const docData = docSnapshot.data();
  let hotTopicsArray: HotTopic[] = [];
  for (let key in docData) {
    if (docData[key].keyWords) {
      const keyWordsReformted = docData[key].keyWords.map((keyWord: string) =>
        keyWord.trim().toLowerCase()
      );
      const reformatedHotTopic = {
        ...docData[key],
        label: docData[key].label.trim().toLowerCase(),
        keyWords: keyWordsReformted,
      };
      hotTopicsArray.push(reformatedHotTopic as HotTopic);
    }
  }
  hotTopicsArray.forEach((hotTopic) => {
    writeToHotTopicsDatabase(hotTopic);
  });
};

/* --------  Cheat Sheets -------- */

export async function addDocument(document: File, cheatSheetId: string) {
  if (document) {
    const sanitizedDocumentName = document.name.replace(/\s+/g, "_");
    const fileRef = ref(
      storage,
      `CheatSheets/${cheatSheetId}/${sanitizedDocumentName}`
    );

    const snapshot = await uploadBytes(fileRef, document);
    const firebaseUrl = await getDownloadURL(snapshot.ref);
    return firebaseUrl;
  }
}

export async function deleteFolderContents(cheatSheetId: string) {
  if (!cheatSheetId) return;

  const listRef = ref(storage, `CheatSheets/${cheatSheetId}`);
  const listResults = await listAll(listRef);
  for (const itemRef of listResults.items) {
    await deleteObject(itemRef);
  }
}

export async function addCheatSheetToDatabase(cheatSheet: CheatSheet) {
  const cheatSheetRef = doc(
    db,
    `${practiceDataBase.PCCheatSheets}/`,
    cheatSheet.cheatSheetId
  );
  await setDoc(cheatSheetRef, cheatSheet);
}

export async function listenToCheatSheets(
  callback: (data: CheatSheet[]) => void
) {
  const cheatSheetsRef = collection(db, practiceDataBase.PCCheatSheets);
  const unsubscribe = onSnapshot(cheatSheetsRef, (snapshot) => {
    const cheatSheets: CheatSheet[] = [];
    snapshot.docs.forEach((doc) => {
      cheatSheets.push(doc.data() as CheatSheet);
    });
    callback(cheatSheets);
  });
  return unsubscribe;
}

export async function deleteCheatSheet(cheatSheetId: string) {
  const cheatSheetRef = doc(db, practiceDataBase.PCCheatSheets, cheatSheetId);
  await deleteDoc(cheatSheetRef);
}

/* --------  Cloud Functions -------- */

export async function addUserToOktaGroup(email: string) {
  const url = "https://addusertookta-gq4krw3ydq-uc.a.run.app";
  const body = JSON.stringify({ email: email });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json();
    console.log("response: ", data);
    return data;
  } catch (error) {
    console.error("There has been a problem with your fetch operation:", error);
  }
}

export async function sendNotification(message: string, userId: String) {
  const url =
    "https://us-central1-hillsong-pastoral-care.cloudfunctions.net/SendNotification";
  const body = JSON.stringify({ userId: userId, message: message });

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json();
    console.log("response: ", data);
    return data;
  } catch (error) {
    console.error("There has been a problem with your fetch operation:", error);
  }
}

/* --------  Cloud Messaging -------- */

export const messaging = async () => (await isSupported()) && getMessaging(app);
export const VAPID_KEY =
  "BPk2xA9Zld97kCFyLI-Yu3fhbfsXd1NOT4BQRzA7LMYahu-dFN_Z41yjFCASCV7mc6JA1TVo627aLPREgaFMpak";
const FCM_TOKEN_COLLECTION = "fcmTokens";

export async function checkNotificationPermissions(): Promise<
  string | undefined
> {
  const msg = await messaging();
  if (!msg) {
    console.error("Messaging is not supported in this browser.");
    return;
  }
  if (Notification.permission === "granted") {
    const fcmToken = await getToken(msg, { vapidKey: VAPID_KEY });
    console.log("FCM Token: ", fcmToken);
    return fcmToken;
  } else {
    console.log("Unable to get permission to notify.");
  }
}

export async function setuptOnMessage() {
  const msg = await messaging();
  if (!msg) {
    console.error("Messaging is not supported in this browser.");
    return;
  }

  onMessage(msg, (message) => {
    console.log("Received foreground notification. ", message);
    if (message.data) {
      new Notification(message.data.title, {
        body: message.data.body,
        icon: message.data.icon,
        tag: message.data.tag,
      });
    }
  });
}

export async function getFCMToken() {
  const msg = await messaging();
  if (!msg) {
    console.error("Messaging is not supported in this browser.");
    return;
  }
  if (Notification.permission !== "granted") {
    const tokenToReturn = await getToken(msg, { vapidKey: VAPID_KEY });
    console.log("FCM Token: ", tokenToReturn);
    onMessage(msg, (message) => {
      console.log("Received foreground notification. ", message);
      if (message.data && message.data.title && message.data.body) {
        new Notification(message.data.title, {
          body: message.data.body,
          icon: message.data.icon,
          tag: message.data.tag,
        });
      }
    });
    return tokenToReturn;
  }
}

export async function saveMessagingDeviceToken(
  userData: UserData,
  token: string
) {
  const userNotificationProfileRef = doc(
    db,
    FCM_TOKEN_COLLECTION,
    userData.userId
  );
  let notificationProfile = await getDoc(userNotificationProfileRef);
  const userNotificationProfileData = notificationProfile.data();

  if (
    userNotificationProfileData &&
    userNotificationProfileData.tokens.includes(token)
  ) {
    console.log("Token already exists.");
  } else if (userNotificationProfileData) {
    await updateDoc(userNotificationProfileRef, {
      tokens: arrayUnion(token),
    });
    console.log("Token Added to Notification Profile.");
  } else {
    await setDoc(userNotificationProfileRef, {
      userId: userData.userId,
      services: ["PCReportReminder", "PCImportantInformation"],
      tokens: [token],
    });
    console.log("New Notification Profile Created");
  }
}

export function listenToExistingNotificationProfile(
  userId: string,
  callback: (data: NotificationProfile) => void
) {
  const tokenRef = doc(db, FCM_TOKEN_COLLECTION, userId);
  const unsubscribe = onSnapshot(tokenRef, (docSnapshot) => {
    if (docSnapshot.exists()) {
      let userNotificationProfile = docSnapshot.data() as NotificationProfile;
      callback(userNotificationProfile);
    } else {
      console.warn("User Notification Profile does not exist!");
    }
  });
  return unsubscribe;
}

export async function removeTokenFromExistingNotificationProfile(
  token: string
) {
  const profileRef = collection(db, FCM_TOKEN_COLLECTION);
  const q = query(profileRef, where("tokens", "array-contains", token));
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    updateDoc(doc.ref, {
      tokens: arrayRemove(token),
    });
  });
}
